<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showBlog") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #2f6a68">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->
      <div class="badges_wrapper justify-content-between">
        <div class="wrapper">
          <v-chip color="amber darken-2" text-color="white">
            {{ $t("TABLES.Blogs.views") }}: {{ data.views_count }}
          </v-chip>
        </div>

        <v-chip :color="data.is_active ? 'green' : 'red'" text-color="white">
          {{ data.is_active ? $t("STATUS.active") : $t("STATUS.notActive") }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badges ==== -->

      <!-- ==== Start:: Blog Data ==== -->
      <form>
        <div class="row">
          <!-- Start:: Image Preview -->
          <div class="preview-container" v-if="data.image">
            <img :src="data.image" :alt="$t('PLACEHOLDERS.blogImage')" />
          </div>
          <!-- End:: Image Preview -->

          <!-- Start:: Title Arabic Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleAr')"
            v-model.trim="data.title_ar"
            disabled
          />
          <!-- End:: Title Arabic Input -->

          <!-- Start:: Title English Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleEn')"
            v-model.trim="data.title_en"
            disabled
          />
          <!-- End:: Title English Input -->

          <!-- Start:: Description Arabic Input -->
          <base-input
            col="6"
            rows="3"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.description_ar"
            disabled
          />
          <!-- End:: Description Arabic Input -->

          <!-- Start:: Description English Input -->
          <base-input
            col="6"
            rows="3"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.description_en"
            disabled
          />
          <!-- End:: Description English Input -->

          <!-- Start:: Content Arabic -->
          <div class="col-12 my-3">
            <h6 class="mb-2">{{ $t("PLACEHOLDERS.contentAr") }}</h6>
            <div
              class="content_preview"
              v-html="data.content_ar"
              style="
                border: 1px solid #ccc;
                padding: 15px;
                border-radius: 5px;
                min-height: 100px;
                background: #f9f9f9;
              "
            ></div>
          </div>
          <!-- End:: Content Arabic -->

          <!-- Start:: Content English -->
          <div class="col-12 my-3">
            <h6 class="mb-2">{{ $t("PLACEHOLDERS.contentEn") }}</h6>
            <div
              class="content_preview"
              v-html="data.content_en"
              style="
                border: 1px solid #ccc;
                padding: 15px;
                border-radius: 5px;
                min-height: 100px;
                background: #f9f9f9;
              "
            ></div>
          </div>
          <!-- End:: Content English -->

          <!-- Start:: Meta Title Arabic Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.metaTitleAr')"
            v-model.trim="data.meta_title_ar"
            disabled
          />
          <!-- End:: Meta Title Arabic Input -->

          <!-- Start:: Meta Title English Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.metaTitleEn')"
            v-model.trim="data.meta_title_en"
            disabled
          />
          <!-- End:: Meta Title English Input -->

          <!-- Start:: Meta Description Arabic Input -->
          <base-input
            col="6"
            rows="2"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.metaDescAr')"
            v-model.trim="data.meta_desc_ar"
            disabled
          />
          <!-- End:: Meta Description Arabic Input -->

          <!-- Start:: Meta Description English Input -->
          <base-input
            col="6"
            rows="2"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.metaDescEn')"
            v-model.trim="data.meta_desc_en"
            disabled
          />
          <!-- End:: Meta Description English Input -->

          <!-- Start:: Created At Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('TABLES.Blogs.createdAt')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Created At Input -->

          <!-- Start:: Updated At Input -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('TABLES.Blogs.createdAt')"
            v-model.trim="data.updated_at"
            disabled
          /> -->
          <!-- End:: Updated At Input -->
        </div>
      </form>
      <!-- ==== End:: Blog Data ==== -->
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowBlog",

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Data
      data: {
        image: null,
        title_ar: null,
        title_en: null,
        description_ar: null,
        description_en: null,
        content_ar: null,
        content_en: null,
        meta_title_ar: null,
        meta_title_en: null,
        meta_desc_ar: null,
        meta_desc_en: null,
        views_count: 0,
        is_active: false,
        created_at: null,
        updated_at: null,
      },
      // End:: Data
    };
  },

  methods: {
    // Start:: Get Blog Data
    async getBlogData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `blogs/${this.id}`,
        });
        // console.log("Blog Data =>", res.data.data.blog);
        const blogData = res.data.data.Blog;
        this.data.image = blogData?.image;
        this.data.title_ar = blogData?.title_ar;
        this.data.title_en = blogData?.title_en;
        this.data.description_ar = blogData?.description_ar;
        this.data.description_en = blogData?.description_en;
        this.data.content_ar = blogData?.content_ar;
        this.data.content_en = blogData?.content_en;
        this.data.meta_title_ar = blogData?.title_seo_ar;
        this.data.meta_title_en = blogData?.title_seo_en;
        this.data.meta_desc_ar = blogData?.description_seo_ar;
        this.data.meta_desc_en = blogData?.description_seo_en;
        this.data.views_count = blogData?.view;
        this.data.is_active = blogData?.is_active;
        this.data.created_at = blogData?.created_at;
        this.data.updated_at = blogData?.updated_at;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Blog Data
  },

  async created() {
    // Start:: Fire Methods
    await this.getBlogData();
    // End:: Fire Methods
  },
};
</script>
